export default class InvalidAnswerTypeError extends Error {
    constructor(type: string) {
        super(`${type} is not a valid answer type`);
    }
}
